'use strict';
import * as _ from 'lodash';
import { module } from '../app';
import moment from 'moment';
import * as commonConstants from '../constants/constantStrings';

module
  .factory('DocumentCreateDialogModel', [
    '$q', 'dataRetrieverService', 'authService', 'documentsSvc', 'modalService', '$ionicLoading', 'signalrService',
    function ($q, dataRetrieverService, authService, documentsSvc, modalService, $ionicLoading, signalrService) {

      function DocumentCreateDialogModel(patientSsn, sdate, checkIfStillOwningAndNotOffline) {
        let self = this;

        self.loading = false;
        self.modalInstance = null;
        self.showValidationResults = false;
        self.templates = null;
        self.patientInfo = {
          Ssn: patientSsn,
          SDate: sdate
        };
        self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;

        self.pdfFormServerUrl = authService.currentMagViewUrl();

        self.init = async (modal, scope) => {
          self.modalInstance = modal;
          self._scope = scope;

          await self.reloadDocumentTemplates();
        };

        self.reloadDocumentTemplates = async () => {
          $ionicLoading.show('Please wait...');
          try {
            let worklistDocumentTemplates = await dataRetrieverService.cachedProxy('worklist-documents-templates', 0, () => documentsSvc.getSignatureForms());
            self.templates = worklistDocumentTemplates.data;
            self.documentLoadedError = false;
          } catch (error) {
            $ionicLoading.hide();
            self.documentLoadedError = true;
            await modalService.showAlertAsync(`Error while getting document templates. Please try again.`);
            return;
          }
          $ionicLoading.hide();
        };

        self.resetForm = () => {
          self.formName = null;
          self.formSettings = null;
        };

        self.validChange = isValid => {
          self.valid = isValid;
        };

        self.documentPagesLoaded = $event => {
          $ionicLoading.hide();
          self.documentLoaded = true;
        };

        self.documentPagesError = async $event => {
          $ionicLoading.hide();
          await modalService.showAlertAsync(`There is one or more document pages cannot be loaded`);
          self.documentLoadedError = true;
        };

        self.onError = async $event => {
          $ionicLoading.hide();
          await modalService.showErrorMessage($event);
          self.close();
        };

        self.initEditor = async (formName, pdfFormId) => {
          if (!signalrService.isConnected) {
            await modalService.showAlertAsync(`You are currently offline, please check your network settings and try again`);
            return;
          }
          self.loading = true;
          self.documentLoaded = false;
          self.formName = formName;
          self.pdfFormId = pdfFormId;

          $ionicLoading.show({
            template: 'Loading document, please wait...'
          });
          try {

            const r = await documentsSvc.getFormSettings(self.formName);

            self.formSettings = r.data.settings || [];
            self.docType = r.data.docType;
            self.docDescription = r.data.docDescription;
            self.loading = false;

            setTimeout(() => {
              if (!self.documentLoaded && !self.documentLoadedError) {
                self.documentPagesLoaded();
              }
            }, 1000);
          } catch (error) {
            await modalService.showAlertAsync(`Error while getting document template. Please try again.`);
            self.formName = null;
            self.formSettings = null;
            self.loading = false;
          }
        };

        self.closeWindow = async () => {
          if (self._hasChanged()) {
            const confirmed = await modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to cancel?');

            if (confirmed) {
              self.close();
            }

            return;
          }
          self.close();
        };

        self.saveForm = async () => {
          let canProceed = true;
          self.showValidationResults = true;
          if (!self.valid) {
            self.highlightInvalidElements();
            await modalService.showAlertAsync('Some required fields are empty');
            canProceed = false;
          }

          if (canProceed && !signalrService.isConnected) {
            await modalService.showAlertAsync(`You are currently offline, please check your network settings and try again`);
            canProceed = false;
          }

          if(canProceed){
            $ionicLoading.show({template: commonConstants.processingLoaderMessage});
            const stilOwning = await self.checkIfStillOwningAndNotOffline();
            $ionicLoading.hide();
            if(!stilOwning){
              canProceed = false;
              self.close();
            }
          }

          if(canProceed){
            $ionicLoading.show({
              template: 'Saving document, please wait...'
            });

            let config = self.formSettings;
            documentsSvc.createDocument(patientSsn, sdate, self.formName, config, self.docType, self.docDescription)
            .then((resp) => {
              $ionicLoading.hide();
              self._scope.model.isSaved = true;
              self.close();
            })
            .catch((error) => {
              $ionicLoading.hide();
              modalService.showErrorMessage(error.data && error.data.message || error.data);
            });
          }
        };

        self.highlightInvalidElements = () => {
          self.formSettings.forEach(setting => {
            const requiredSetting = setting.options.find(option => option.name === "Required");
            setting.highlightInvalidElement = requiredSetting && requiredSetting.value == true && !setting.data;
          });
        };

        self.close = (showConfirmationModal) => {
          if (showConfirmationModal && self.formName) {
            modalService.showConfirmation(null, 'Are you sure you want to close this window without saving changes?')
                        .then((isConfirmed) => {
                          if (isConfirmed) {
                            self.modalInstance.remove();
                          }
                        });
          } else {
            self.modalInstance.remove();
          }
        };
      }

      return DocumentCreateDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/documentCreateDialogModel.js